import request from '@/utils/request'

// const tjuBaseUrl = '//tju-simple-class.zhihuishu.com'

// 获取当前选中机构的所有老师：
export const searchUser = (params) => {
  return request({
    url: '/admin/live/searchUser',
    method: 'get',
    params
  })
}

// 获取当前选中机构的所有老师：
export const searchUserInfo = (params) => {
  return request({
    url: '/admin/live/searchUserInfo',
    method: 'get',
    params
  })
}

// 获取学期列表
export const getTermInfo = (params) => {
  return request({
    url: '/admin/school/getTermInfo/v100',
    method: 'get',
    params
  })
}

// 获取当前选中机构的所有导播
export const searchDirector = (params) => {
  return request({
    url: '/admin/live/searchDirector',
    method: 'get',
    params
  })
}
// 获取当前选中学校的教室
export const searchClassroom = (params) => {
  return request({
    url: '/admin/live/searchClassroom',
    method: 'get',
    params
  })
}

// 新建课程
export const createCourse = (params) => {
  return request({
    url: '/admin/course/createCourse',
    method: 'post',
    data: params
  })
}
// 新建直播
export const createLive = (params) => {
  return request({
    url: '/admin/live/createLive',
    method: 'post',
    data: params
  })
}
// 编辑直播
export const editLive = (params) => {
  return request({
    url: '/admin/live/editLive',
    method: 'post',
    data: params
  })
}
// 编辑直播弹出框显示的字段
export const editLiveDisplayInfo = (params) => {
  return request({
    url: '/admin/live/editLiveDisplayInfo',
    method: 'get',
    params
  })
}
